import React from "react";

const ReturnAndRefund = () => {
  const returnPolicyDays = 7 ; // <-- CHANGE THIS

  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        {/* Page Title */}
        <h1 className="text-4xl font-bold text-gray-800">Return & Refund Policy</h1>
        <p className="text-gray-600">Thank you for shopping at Pure Clean Shopping.</p>
        <p className="text-gray-600">
          If you are not entirely satisfied with your purchase, we're here to help.
        </p>

        {/* Returns Section */}
        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">Returns</h2>
          <p className="text-gray-600">
            You have {returnPolicyDays} calendar days to return an item from the date you received it.
          </p>
          <p className="text-gray-600">
            To be eligible for a return, your item must be unused and in the same condition that you received it. It must also be in the original packaging.
          </p>
          <p className="text-gray-600">
            Several types of goods are exempt from being returned. Perishable goods such as food, flowers, newspapers, or magazines cannot be returned. We also do not accept products that are intimate or sanitary goods, hazardous materials, or flammable liquids or gases.
          </p>
        </section>

        {/* Refunds Section */}
        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">Refunds</h2>
          <p className="text-gray-600">
            Once we receive your item, we will inspect it and notify you that we have received your returned item. We will immediately notify you on the status of your refund after inspecting the item.
          </p>
          <p className="text-gray-600">
            If your return is approved, we will initiate a refund to your credit card (or original method of payment). You will receive the credit within a certain amount of days, depending on your card issuer's policies.
          </p>
        </section>

        {/* Shipping Section */}
        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">Shipping</h2>
          <p className="text-gray-600">
            You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund.
          </p>
        </section>

        {/* Contact Section */}
        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">Contact Us</h2>
          <p className="text-gray-600">
            If you have any questions on how to return your item to us, contact us at{" "}
            <a href="mailto:contact@purecleanshopping.info" className="text-indigo-600 hover:underline">
              contact@purecleanshopping.info
            </a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ReturnAndRefund;
